import React from 'react';
import { Band } from './Band';
import { scenarioClasses } from '../../data/site';
export function Scenarios() {
  return <Band id="scenarios" eyebrow="Calibrated judgement" title="Four kinds of scenario. Only one contains an error." description="Six scenarios drawn from four classes, and the candidate is never told which is which. Only one class contains an error at all. The rest are difficult for the reasons real work is difficult — evidence that conflicts, evidence that is scattered, and evidence that is simply correct." data-id="element-355" data-mp="38tvp9fwqvell">
      <div className="grid gap-4 md:grid-cols-2" data-id="element-356" data-mp="2pxm64e6zjxuq">
        {scenarioClasses.map(item => <article key={item.name} className={`flex flex-col rounded-2xl border bg-white/70 p-8 lg:p-9 ${item.clean ? 'border-teal border-l-[3px] border-l-teal' : 'border-mist'}`} data-id="element-357" data-mp="2c5pfkekytw0g">
            <span className={`font-mono text-xs uppercase tracking-[0.2em] ${item.clean ? 'text-teal' : 'text-muted'}`} data-id="element-358" data-mp="225yo6lrpbx4l">
              {item.count}
            </span>
            <h3 className="mt-4 font-display text-2xl font-medium text-ink" data-id="element-359" data-mp="277e644yl1nir">
              {item.name}
            </h3>
            <p className="mt-4 max-w-[52ch] text-lg leading-relaxed text-graphite" data-id="element-360" data-mp="11edsy9zw79bv">
              {item.what}
            </p>
            <p className="mt-6 border-t border-mist pt-5 text-[15px] leading-relaxed text-ink" data-id="element-361" data-mp="1fcvdjyui45pk">
              <span className="font-mono text-xs uppercase tracking-[0.14em] text-teal" data-id="element-362" data-mp="1bdcul8m8q4pd">
                Reveals ·{' '}
              </span>
              {item.reveals}
            </p>
          </article>)}
      </div>

      <figure className="mt-6 max-w-2xl" data-id="element-363" data-mp="ioxk8ze20akd">
        <div className="rounded-2xl border border-mist bg-white px-6 py-5" data-id="element-364" data-mp="wf0wcxj7ynw3">
          <figcaption className="font-mono text-xs uppercase tracking-[0.14em] text-teal" data-id="element-365" data-mp="wh5b6ainp7b5">
            Scenario 4 · clean case
          </figcaption>
          <p className="mt-3 font-mono text-[15px] leading-relaxed text-ink" data-id="element-366" data-mp="3xyc1ph4ro1b">
            Over-checked. Source queried three times across 11 minutes. No
            discrepancy existed.{' '}
            <span className="text-clay" data-id="element-367" data-mp="1z2fx8rypwkka">Partial credit.</span>
          </p>
        </div>
        <p className="mt-4 max-w-[70ch] text-sm leading-relaxed text-muted" data-id="element-368" data-mp="240pr8z8phf4b">
          A clean case is only meaningful if the candidate could plausibly have
          doubted it. We build them to be genuinely arguable, and we report the
          cases where they were not.
        </p>
      </figure>
    </Band>;
}